import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type Props = {
  startsAt?: string
  endsAt?: string
  location?: string | null
  link?: string | null
}

export const EventInfo = ({ endsAt, startsAt, link, location }: Props) => {
  const date = startsAt ? dateToString(moment(startsAt), 'ui_dmy_long') : undefined
  const start = startsAt && dateToString(moment(startsAt), 'ui_time')
  const end = endsAt && dateToString(moment(endsAt), 'ui_time')

  return (
    <Box gap="s8">
      <Text.Normal size="300" color="grey1000" capitalize>
        {date
          ? i18n.t('trainings.trainings_revamp.employee_sidepanel.date', {
              date,
              start,
              end,
            })
          : i18n.t('trainings.trainings_revamp.employee_sidepanel.self-paced')}
      </Text.Normal>
      {location && (
        <Box flexDirection="row" gap="s8">
          <Icon.Medium icon="pin"></Icon.Medium>
          <Text.Normal size="300" color="grey1000" capitalize>
            {location}
          </Text.Normal>
        </Box>
      )}
      {link && (
        <Box flexDirection="row" gap="s8">
          <Icon.Medium icon="laptop"></Icon.Medium>
          <Text.Normal size="300" color="grey1000" capitalize>
            {i18n.t('trainings.trainings_revamp.employee_sidepanel.link')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}
